import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankCriteria } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },

  [mutation.LIST_SET_CRITERIA](state, searchCriteria) {
    stateMerge(state.listing.criteria, searchCriteria);
  },
  [mutation.LIST_CLEAR_CRITERIA](state) {
    stateMerge(state.listing.criteria, getBlankCriteria());
  },
  [mutation.LIST_KEEP_CRITERIA](state, keep) {
    state.listing.keepCriteria = keep;
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_TOGGLE_EXPAND](state, index) {
    var newValue = !state.listing.expanded[index];
    state.listing.expanded.splice(index, 1, newValue);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, logs) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = logs;
    state.listing.expanded = new Array(logs.length).fill(false);
  },

  [mutation.EXPORT_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_FAILED](state) {
    state.listing.loading = false;
  }
};
